export default __webpack_public_path__ + "static/media/mapIcon.9cb3a144.svg";